import { render, staticRenderFns } from "./AllowlistingDialog.vue?vue&type=template&id=20ba43f5&scoped=true&"
import script from "./AllowlistingDialog.vue?vue&type=script&lang=js&"
export * from "./AllowlistingDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllowlistingDialog.vue?vue&type=style&index=0&id=20ba43f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba43f5",
  null
  
)

export default component.exports